import React from 'react'
import { toast } from 'react-hot-toast'
import { FiCheckCircle } from 'react-icons/fi'

export { LoaderComponent } from '../component/loader/Loader'
export type { LoaderComponentProps } from '../component/loader/Loader'

export const limitPagination: number = 10
interface ConfirmDeleteToastProps {
  onConfirm: () => void
  onCancel: () => void
  message?: string
}

export const ConfirmDeleteToast: React.FC<ConfirmDeleteToastProps> = ({
  onConfirm,
  onCancel,
  message = 'Are you sure?',
}) => {
  return (
    <ConfirmActionToast
      message={message}
      confirmLabel='Yes'
      confirmClassName='bg-red-600 text-white py-2 px-4 rounded-md hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-600 focus:ring-opacity-50'
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  )
}

interface ConfirmActionToastProps {
  onConfirm: () => void
  onCancel: () => void
  message?: string
  confirmLabel?: string
  cancelLabel?: string
  confirmClassName?: string
}

export const ConfirmActionToast: React.FC<ConfirmActionToastProps> = ({
  onConfirm,
  onCancel,
  message = 'Are you sure?',
  confirmLabel = 'Yes',
  cancelLabel = 'No',
  confirmClassName = 'bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:ring-opacity-50',
}) => {
  return (
    <div className='flex flex-col items-center space-y-4'>
      <p className='text-xl font-semibold text-gray-800'>{message}</p>
      <div className='flex space-x-4'>
        <button
          onClick={() => {
            onConfirm()
            toast.dismiss()
          }}
          className={confirmClassName}
        >
          {confirmLabel}
        </button>
        <button
          onClick={() => {
            onCancel()
            toast.dismiss()
          }}
          className='bg-gray-300 text-gray-700 py-2 px-4 rounded-md hover:bg-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-600 focus:ring-opacity-50'
        >
          {cancelLabel}
        </button>
      </div>
    </div>
  )
}

export const ucFirst = (str: string) => {
  if (!str) return str // If the string is empty, return it as it is
  return str.charAt(0).toUpperCase() + str.slice(1)
}

export const successMessage = (message: string) => {
  return toast.success(message, {
    icon: <FiCheckCircle color={'var(--success-600)'} size={30} />,
  })
}

export const errorMessageShow = (message: string) => {
  return toast.error(message)
}

export const convertDate = (date: string) => {
  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  }
  const formattedDate = new Date(date).toLocaleDateString('en-US', options)
  return formattedDate
}

export const cleanTopicsString = (input: string): string => {
  input = input.replace(/,\s*$/, '')
  input = input.replace(/\(([^)]*)\)/g, (match: string) => {
    return match.replace(/,/g, ' ')
  })
  return input
}
